import { useEffect, useState } from "react";
import LeadClientInput from "../shared/LeadClientInput";
import SelectDropdown from "../ui/SelectDropdown";
import { portalFilterOptions } from "../../data/portalFormListData";
import filtersIcon from "../../assets/icons/filter-light.svg";
import closeIcon from "../../assets/icons/close-cross-dark-heavy.svg";

const PortalDealListFilters = ({ onDidSelectMember, onDidChangeFilter, currentFilter, stageButtons }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {}, [onDidSelectMember, onDidChangeFilter]);

    const updateSelectedClientLead = (newLead) => {
        onDidSelectMember(newLead);
    };

    const updatedMainFilter = (newFilter) => {
        onDidChangeFilter(newFilter);
    };

    const toggleFilters = () => {
        setIsVisible(!isVisible);
    };

    const resetFilters = () => {
        onDidSelectMember(null);
        onDidChangeFilter("all");
    };

    return (
        <>
            {stageButtons}

            <div className="portal--filter_toggle">
                <button onClick={toggleFilters}>
                    <img src={isVisible ? closeIcon : filtersIcon} alt="" />
                    <span>Filter</span>
                </button>
            </div>

            <div className="portal--filter-search-wrapper">
                <LeadClientInput
                    value={(fromValue) => updateSelectedClientLead(fromValue)}
                    required={false}
                    label="Lead/Client"
                    placeholder="SEARCH LEAD/CLIENT"
                    skeleton={false}
                    showReset={false}
                />
            </div>

            {isVisible && (
                <div className="portal--filter-inline">
                    <div className="portal--filter-row">
                        <label>Filter deals:</label>
                        <SelectDropdown
                            options={portalFilterOptions}
                            value={currentFilter}
                            onChange={updatedMainFilter}
                        />
                    </div>
                    <div className="portal--filter-reset">
                        <button onClick={resetFilters}>
                            <span>Reset</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default PortalDealListFilters;
